import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from '../home/home.component';
import { MainLayoutComponent } from '../layouts/main-layout/main-layout.component';
import { LoginLayoutComponent } from '../layouts/login-layout/login-layout.component';
import { LoginComponent } from '../login/login.component';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { RoutePath } from './routes';
import { UserRolesComponent } from 'app/user-roles/user-roles.component';
import { EventsComponent } from 'app/events/events.component';
import { SchoolsComponent } from 'app/schools/schools.component';
import { CategoriesComponent } from 'app/categories/categories.component';
import { HallOfFameComponent } from 'app/hall-of-fame/hall-of-fame.component';
import { BulletinComponent } from 'app/bulletin/bulletin.component';
import { AuthGuard } from 'app/_guards/auth.guard';
import { RoleNames } from 'app/_models';
import { MaintenanceComponent } from 'app/maintenance/maintenance.component';
import { MaintenanceGuard } from 'app/_guards/maintenance.guard';
import { PageNotAuthroizedComponent } from 'app/page-not-authroized/page-not-authroized.component';
import { AuthService } from 'app/_services/auth.service';
import { CalendarWidgetComponent } from 'app/calendar-widget/calendar-widget.component';
import { LegislationComponent } from 'app/legislation/legislation.component';
import { RecipientsGroupsComponent } from 'app/legislation/recipients-groups/recipients-groups.component';
import { LegislativeFormWidgetComponent } from 'app/legislation/legislation-form/legislative-form-widget.component';
import { HomepageGuard } from 'app/_guards/homepage.guard';
import { FeedComponent } from 'app/wordpress-feed/feed.component';
import { Feed2Component } from 'app/wordpress-feed/feed2.component';
import { DevTestPageComponent } from 'app/dev-test-page/devtestpage.component';


const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [MaintenanceGuard],
        children: [
            { path: '', redirectTo: '', canActivate: [HomepageGuard], pathMatch: 'full' },
            {
                path: RoutePath.Home,
                component: HomeComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.DistrictWebsite], title: 'Dashboard' },
            },
            {
                path: RoutePath.CalendarWidget,
                component: CalendarWidgetComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.DistrictWebsite], title: 'Calendar Widget' },
            },
            {
                path: RoutePath.UserRoles,
                component: UserRolesComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin], title: 'Users and Roles' },
            },
            {
                path: RoutePath.Events,
                component: EventsComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.DistrictWebsite], title: 'Events' },
            },
            {
                path: RoutePath.Feeds,
                component: FeedComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin], title: 'Feeds' },
            },
            {
                path: RoutePath.Feeds2,
                component: Feed2Component,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin], title: 'Feeds2' },
            },
            {
                path: RoutePath.Bulletin,
                component: BulletinComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.DistrictWebsite], title: 'Bulletin' },
            },
            {
                path: RoutePath.Categories,
                component: CategoriesComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.DistrictWebsite], title: 'Categories' },
            },
            {
                path: RoutePath.HallOfFame,
                component: HallOfFameComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.DistrictWebsite], title: 'Hall Of Fame' },
            },
            {
                path: RoutePath.LegislationInfo,
                component: LegislationComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.Legislative], title: 'Legislative Items' },
            },
            {
                path: RoutePath.LegislationForm,
                component: LegislativeFormWidgetComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.Legislative], title: 'Legislative Form' },
            },
            {
                path: RoutePath.LegislationGroups,
                component: RecipientsGroupsComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.Legislative], title: 'Legislative Groups' },
            },
            {
                path: RoutePath.Schools,
                component: SchoolsComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin, RoleNames.DistrictWebsite], title: 'Schools' },
            },
            {
                path: RoutePath.DevTestPage,
                component: DevTestPageComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleNames.Admin], title: 'DevTestPage' },
            },
        ],
    },

    // Separate Login Layout to hide navigation menues on login page.
    {
        path: '',
        component: LoginLayoutComponent,
        children: [
            { path: RoutePath.Maintenance, component: MaintenanceComponent },
            { path: RoutePath.Login, component: LoginComponent, canActivate: [MaintenanceGuard], data: { title: 'Login' } },
        ],
    },

    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [MaintenanceGuard],
        children: [
            { path: RoutePath.PageNotAuthorized, component: PageNotAuthroizedComponent, data: { title: 'Unauthorized Access' } },
            { path: RoutePath.PageNotFound, component: PageNotFoundComponent, data: { title: '404 Page Not Found' } },
            { path: '**', redirectTo: `/${RoutePath.PageNotFound}` },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule],
    providers: [AuthService],
})
export class AppRoutingModule {}
